/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */const i={STANDARD:"cubic-bezier(0.2, 0, 0, 1)",EMPHASIZED:"cubic-bezier(.3,0,0,1)",EMPHASIZED_ACCELERATE:"cubic-bezier(.3,0,.8,.15)"};function n(){let e=null;return{start(){return e==null||e.abort(),e=new AbortController,e.signal},finish(){e=null}}}export{i as EASING,n as createAnimationSignal};
